import { useEffect, useState } from "react";
import { getFAQsAPI } from "../../service/ai.service";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const FAQ = () => {
    const [faqs, setFaqs] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        getFAQsAPI()
            .then((response) => {
                setFaqs(response);
            })
            .catch((error) => {
                console.error("Error fetching FAQs:", error);
            });
    }, []);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const render = () => {
        return (
            <div >
                {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;
                    return (
                        <div key={index} className="pb-3">
                            <button onClick={() => toggleFAQ(index)} className="faq-question" style={{ color: isOpen ? "#2563eb" : "#111" }}>
                                {index + 1}. {faq.question}
                            </button>
                            <div
                                style={{
                                    maxHeight: isOpen ? "inherit" : "0px",
                                    overflow: "hidden",
                                    transition: "max-height 0.3s ease",
                                    color: "#555"
                                }}
                            >
                                <p style={{ marginTop: isOpen ? "10px" : "0px", whiteSpace: 'pre-wrap', marginLeft: 30 }} dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.FAQS}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/track-record'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.TRACK_RECORD}</p></DisabledNavLink>
                    <DisabledNavLink to='/client-assistance-channel'><p className="m-0 p-0">{SECTION_NAMES.CLIENT_ASSISTANCE_CHANNEL}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <div className="m-5">
                {render()}
            </div>
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/track-record')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/client-assistance-channel')}></button>
            </div> */}
        </>
    );
};

export default FAQ;
